export const i = {
	'index_welcome': 'Welcome',
	'index_introduce': '-',
	'index_contact': 'Contact Info',
	'index_contact_phone': 'Telephone',
	'index_artcleCategory': 'Artcle Category',
	'index_all': 'All',
	'index_technology': 'Technology',
	'index_life': 'Life',
	'index_photography': 'Photography',
	'index_other': 'Other'
}
